import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation deleteSavedOffer($offerId: String!) {
    deleteSavedOffer(offerId: $offerId) {
      success
      message
    }
  }
`

export interface DeleteSavedOfferInput {
  offerId: string
}

export interface DeleteSavedOfferOutput {
  deleteSavedOffer: {
    success: boolean
    message: string
  }
}

export const useDeleteSavedOffer = () =>
  useMutation<DeleteSavedOfferOutput, DeleteSavedOfferInput>(mutation)
